<template>
  <v-sheet :height="this.$root.windowHeight">
    <v-container class="fill-height">
      <v-row align="center" justify="center" class="fill-height">
        <v-col>
          <v-row align="center" justify="center">
            <v-col align="center">
              <h1>Nuestra selección del año</h1>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="4" md="4" lg="4" xl="2" align="center">
              <v-card max-width="300">
                <Stories class="absolute top-0 h-100vh w-100vw md:(h-200px w-420px)"
                         :stories="posters"
                         :loop="true"
                         interval="4000"/>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>
  </v-sheet>
</template>

<script>
import axios from "axios";
import {Stories} from "vue-insta-stories";

const BASE_URL = process.env.VUE_APP_API_URL

export default {
  name: "Playlist",
  components: {Stories},
  data: () => ({
    movies: [],
    posters: [],
  }),
  methods: {
    getYearPlaylist() {
      axios(
          {
            method: 'get',
            url: BASE_URL + 'playlists/?name=Selección+' + this.$route.params['year'],
            params: {
              page_size: 0,
              token: this.$route.params['token'],
              user_id: this.$route.params['user_id'],
              year: this.$route.params['year'],
            }
          }
      ).then(res => {
        console.log(res)
        this.movies = res.data[0].movies;
        this.posters = this.parseFilms()
      }).catch(() => {
        console.log("ERROR: Loading Stats")
      })
    },

    parseFilms() {
      let posters = []
      this.movies.forEach(record => {
        posters.push('https://www.themoviedb.org/t/p/w600_and_h900_bestv2/' + record.movie.poster)
      })
      return posters
    }
  },
  mounted() {
    this.getYearPlaylist()
  }
}
</script>

<style scoped>

</style>
